import * as React from "react";

const SvgPbp = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 14 14"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.33329 5.24999V2.33332H8.16663V5.24999H2.33329ZM1.16663 1.74999C1.16663 1.42782 1.42779 1.16666 1.74996 1.16666H8.74996C9.07212 1.16666 9.33329 1.42782 9.33329 1.74999V5.83332C9.33329 6.15549 9.07212 6.41666 8.74996 6.41666H1.74996C1.42779 6.41666 1.16663 6.15549 1.16663 5.83332V1.74999ZM5.83329 11.6667V8.74999H11.6666V11.6667H5.83329ZM4.66663 8.16666C4.66663 7.84449 4.92779 7.58332 5.24996 7.58332H12.25C12.5721 7.58332 12.8333 7.84449 12.8333 8.16666V12.25C12.8333 12.5722 12.5721 12.8333 12.25 12.8333H5.24996C4.92779 12.8333 4.66663 12.5722 4.66663 12.25V8.16666Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgPbp;
